<template>
  <div id="SuccessStory">
    <h2 class="page-title heading">Success Stories</h2>
    <div id="lgscreen" class="d-none d-lg-block">
      <b-row>
        <b-col>
          <iframe
            src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Falepecoraro%2Fposts%2F10157640063579431&width=500"
            width="500"
            height="219"
            style="border: none; overflow: hidden;"
            scrolling="no"
            frameborder="0"
            allowTransparency="true"
            allow="encrypted-media"
          ></iframe>
          <iframe
            src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fkarin.iffrig%2Fposts%2F10220555598865002&width=500"
            width="500"
            height="296"
            style="border: none; overflow: hidden;"
            scrolling="no"
            frameborder="0"
            allowTransparency="true"
            allow="encrypted-media"
          ></iframe>
          <iframe
            src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fmo.grossman%2Fposts%2F2936732779885353&width=500"
            width="500"
            height="162"
            style="border: none; overflow: hidden;"
            scrolling="no"
            frameborder="0"
            allowTransparency="true"
            allow="encrypted-media"
          ></iframe>
        </b-col>
        <b-col>
          <iframe
            src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fdiana.cabrera.5070%2Fposts%2F2903135029714427&width=500"
            width="500"
            height="181"
            style="border: none; overflow: hidden;"
            scrolling="no"
            frameborder="0"
            allowTransparency="true"
            allow="encrypted-media"
          ></iframe>
          <iframe
            src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fkeeirsteen%2Fposts%2F10215062602502118&width=500"
            width="500"
            height="282"
            style="border: none; overflow: hidden;"
            scrolling="no"
            frameborder="0"
            allowTransparency="true"
            allow="encrypted-media"
          ></iframe>
          <iframe
            src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fornella.dechen%2Fposts%2F2600281103349782&width=500"
            width="500"
            height="258"
            style="border: none; overflow: hidden;"
            scrolling="no"
            frameborder="0"
            allowTransparency="true"
            allow="encrypted-media"
          ></iframe>
          <iframe
            src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fshimiagadol%2Fposts%2F10157445531713524&width=500"
            width="500"
            height="142"
            style="border: none; overflow: hidden;"
            scrolling="no"
            frameborder="0"
            allowTransparency="true"
            allow="encrypted-media"
          ></iframe>
        </b-col>
      </b-row>
    </div>

    <div id="smscreen" class="d-block d-lg-none">
      <!-- <b-row> -->
      <iframe
        src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Falepecoraro%2Fposts%2F10157640063579431&width=300"
        width="300"
        height="300"
        style="border: none; overflow: hidden;"
        scrolling="no"
        frameborder="0"
        allowTransparency="true"
        allow="encrypted-media"
      ></iframe>
      <iframe
        src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fkarin.iffrig%2Fposts%2F10220555598865002&width=300"
        width="300"
        height="450"
        style="border: none; overflow: hidden;"
        scrolling="no"
        frameborder="0"
        allowTransparency="true"
        allow="encrypted-media"
      ></iframe>
      <iframe
        src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fmo.grossman%2Fposts%2F2936732779885353&width=300"
        width="300"
        height="200"
        style="border: none; overflow: hidden;"
        scrolling="no"
        frameborder="0"
        allowTransparency="true"
        allow="encrypted-media"
      ></iframe>
      <iframe
        src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fdiana.cabrera.5070%2Fposts%2F2903135029714427&width=300"
        width="300"
        height="240"
        style="border: none; overflow: hidden;"
        scrolling="no"
        frameborder="0"
        allowTransparency="true"
        allow="encrypted-media"
      ></iframe>
      <iframe
        src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fkeeirsteen%2Fposts%2F10215062602502118&width=300"
        width="300"
        height="440"
        style="border: none; overflow: hidden;"
        scrolling="no"
        frameborder="0"
        allowTransparency="true"
        allow="encrypted-media"
      ></iframe>
      <iframe
        src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fornella.dechen%2Fposts%2F2600281103349782&width=300"
        width="300"
        height="375"
        style="border: none; overflow: hidden;"
        scrolling="no"
        frameborder="0"
        allowTransparency="true"
        allow="encrypted-media"
      ></iframe>
      <iframe
        src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fshimiagadol%2Fposts%2F10157445531713524&width=300"
        width="300"
        height="170"
        style="border: none; overflow: hidden;"
        scrolling="no"
        frameborder="0"
        allowTransparency="true"
        allow="encrypted-media"
      ></iframe>
      <!-- </b-row> -->
    </div>
    <!-- <b-col> -->
    <!-- <div class="fb-page" 
        data-tabs="timeline,events,messages"
        data-href="https://www.facebook.com/shanicoaching/"
        data-width="" 
        data-hide-cover="false"></div> -->
    <!-- </b-col> -->
  </div>
</template>
<script>
export default {
  name: "SuccessStory",
  data() {
    return {};
  },
  components: {},
  methods: {},
  created() {},
};
</script>

<style lang="scss">
@import "../../node_modules/rfs/scss";
#SuccessStory {
  padding: 3em 2em 5em 2em;

  .heading {
    margin: 1.5em 0;

    @media screen and (min-width: 992px) {
      margin-top: 0;
    }
  }
}
</style>
